import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Breadcrumbs,
  Button,
  Content,
  Loading,
} from '@orobix/orobix-fe-components'
import { driver } from 'driver.js'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import PageHeader from '../../components/PageHeader/PageHeader'
import { useDispatch, useStore } from '../../store/store'
import {
  emptyProductClasses,
  fetchProduct,
  fetchProductClasses,
  fetchProject,
} from '../../store/storeActions'
import { locations } from '../../utils/locations'
import NewAnomalyTraining from './NewAnomalyTraining'
import NewClassificationTraining from './NewClassificationTraining'
import NewPatchTraining from './NewPatchTraining'
import NewSegmentationTraining from './NewSegmentationTraining'
import useStyles from './TrainingNewRoot.styles'

interface RouteParams {
  projectId: string
  productId: string
}

const TrainingRoot = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { product, project } = useStore()
  const dispatch = useDispatch()
  const { productId, projectId } = useParams<RouteParams>()

  useEffect(() => {
    if (!project) {
      fetchProject(dispatch, Number(projectId))
    }
  }, [dispatch, project, projectId])

  useEffect(() => {
    if (!product) {
      fetchProduct(dispatch, Number(productId))
    }
  }, [dispatch, product, productId])

  useEffect(() => {
    fetchProductClasses(dispatch, Number(productId), 1000, 0)
  }, [dispatch, productId])

  useEffect(
    () => () => {
      emptyProductClasses(dispatch)
    },
    [dispatch]
  )

  const driverObj = driver()

  return product && project ? (
    <Content
      childrenClassName={classes.content}
      breadcrumbs={
        <Breadcrumbs
          elements={[
            <Link to={locations.projects}>{t('Projects')}</Link>,
            <Link to={locations.products(Number(projectId))}>
              {project.name}
            </Link>,
            <Link
              to={locations.trainings(Number(projectId), Number(productId))}
            >
              {product.name}
            </Link>,
            t('New training'),
          ]}
        />
      }
    >
      <PageHeader
        title={t('New training')}
        right={
          <Button
            label={t('Explain me how')}
            hideLabel
            icon={<FontAwesomeIcon icon={faCircleQuestion} size="lg" />}
            type="blank-default"
            onClick={() => {
              driverObj.drive()
            }}
          />
        }
      />
      {
        {
          classification: <NewClassificationTraining />,
          segmentation: <NewSegmentationTraining />,
          classification_patch: <NewPatchTraining />,
          anomaly: <NewAnomalyTraining />,
        }[product.type]
      }
    </Content>
  ) : (
    <Content>
      <Loading />
    </Content>
  )
}

export default TrainingRoot
